"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRequireAuth = useRequireAuth;
var _reactRedux = require("react-redux");
/**
 * Hook that throws an error if the user is logged out.
 * This is useful for protecting routes/components that require authentication.
 *
 * The isLoggedOut flag is set to true when GET_USER_FROM_SESSION_FAILURE occurs,
 * which can happen during token validation even if a user object exists in state.
 *
 * @param {boolean} enabled - Whether to enforce authentication check. Defaults to true.
 * @throws {Error} Throws 'User is Logged out' if isLoggedOut is true and enabled is true
 */
function useRequireAuth() {
  var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var isLoggedOut = (0, _reactRedux.useSelector)(function (state) {
    return state.isLoggedOut;
  });
  if (enabled && isLoggedOut) {
    throw new Error('User is Logged out');
  }
}